<template lang="pug">
.container-fluid
    b-row.mb-3(class="justify-content-between")
        b-col(sm='3' md='4')
            b-form-group.mb-0()
                b-input-group(size='sm')
                    b-form-input#filter-input(v-model='filter' type='search' placeholder='Type to Search')
                    b-input-group-append
                        b-button(:disabled='!filter' @click="filter = ''") Clear
    b-row()
        b-col(sm='5' md='4')
            p(v-if="perPage <= mutations.length") Showing {{ currentPage * perPage }} / {{ mutations.length }} results
            p(v-else) Showing {{ mutations.length }} results
        b-col(sm="7" md="4" offset-md="4" v-if="mutations.length > perPage")
            b-pagination(
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class="my-0")
    b-row
        b-col
            b-table(hover
                v-if="mutations.length !== 0"
                :items="mutations"
                :filter='filter'
                :fields="fields"
                :per-page="perPage"
                :current-page="currentPage"
                )
    b-row.mb-3
        b-col(sm="7" offset-sm="5" md="4" offset-md="8" v-if="mutations.length > perPage")
            b-pagination(
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class="my-0")
</template>

<script>
import axios from 'axios';
export default {
    name: 'Mutations',
    data() {
        return {
            msg: 'Mutations tab',
            mutations: [],
            fields: [
                {key: 'mutationPosition', sortable: true},
                {key: 'referenceAA', sortable: true, label: "Reference amino acid"},
                {key: 'altAA', sortable: true, label: "Mutated amino acid"},
                {key: 'type', sortable: true},
                {key: 'disease', sortable: true}
            ],
            currentPage: 1,
            totalRows: null,
            perPage: 100,
            filter: null,
            stickyHeader: "1000px"
        };
    },
    beforeMount: function() {
        if (this.$store.state.proteinId == null) {
            console.log('getProtein');
            this.getProtein();
        }
        this.getMutations();
    },
    methods: {
        async getMutations() {
            const apiBaseUrl = '/scop3ptm/api/get-mutations';
            const response = await axios
                .get(apiBaseUrl, {
                    params: { protein: this.$store.state.proteinId }
                })
                .catch(err => {
                    if (err.response) {
                        console.log(err.response);
                    }
                });
            this.mutations = response.data.mutations.sort((a, b) => a.mutationPosition - b.mutationPosition);
            this.totalRows = this.mutations.length;
        },
        async getProtein() {
            const apiBaseUrl = '/scop3ptm/api/protein';
            const response = await axios
                .get(apiBaseUrl, {
                    params: { protein: this.$route.params.protein }
                })
                .catch(err => {
                    if (err.response) {
                        console.log(err.response);
                    }
                });
            console.log('protein', response);
            this.$store.commit('setProteinId', response.data.proteins[0].id);
        }
    }
};
</script>
